import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { SponsorService } from 'src/app/services/sponsor.service';

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.page.html',
  styleUrls: ['./sponsors.page.scss'],
})
export class SponsorsPage implements OnDestroy {
  @ViewChild('contentSponsor') contentSponsor: IonContent;

  private _id = this.route.snapshot.paramMap.get('id');
  private _reloadObs = new Subscription();
  public galleries = undefined;
  public loading = true;
  public products: any[] = [];
  public data = { type: 'sponsor', sponsor: this._id }


  constructor(
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private sponsorSv: SponsorService,
    private paramSv: ParamServicesService
  ) {
    this._reloadObs.add(
      this.paramSv.reload.subscribe(() => {
        this.getSponsor();
      })
    )
  }

  ionViewWillEnter(){
    this.getSponsor();
  }

  ngOnDestroy(): void {
    this._reloadObs.unsubscribe();
  }
  
  async getSponsor(){
    try{
      const { products, galleries } = await this.sponsorSv.getSponsor(this._id);
      this.galleries = galleries;
      this.products = products;
      this.loading = false;
    }catch(err){
      console.error(err);
    }
  }

  setGallery(gallery){
    this.navCtrl.navigateForward(`gallery/${gallery.id}`);
    // this.gallery = undefined;
    // setTimeout(async () => {
    //   this.gallery = gallery;
    //   await this.contentSponsor.scrollToTop(500);
    // }, 200)
  }

}
